import GeneEBIGene2PhenotypeCard from "./GeneEBIGene2PhenotypeCard";

export default GeneEBIGene2PhenotypeCard;
